<template>
  <div v-if="activityType" class="activity-type-container" :class="{'minimized': hideActivityInfo, 'stackedHeight': stackedButtons, 'defaultHeight': !stackedButtons}">
    <div class="activity-info-inner-container uk-flex uk-flex-middle uk-visible@s">
      <img @click="toggleActivityInfo" :class="{'close-icon': !hideActivityInfo, 'open-icon': hideActivityInfo}"
           class="add-pointer icon-size" :data-src="resolveIcon(closeIcon)" width="36px" height="36px" uk-img>
      <img :data-src="resolveIcon(activityType)" class="icon-size" width="36px" height="36px" uk-img>
      <span class="activity-info-title" :class="{'hidden': hideActivityInfo}">{{resolveActivity(activityType)}} <br> Activity</span>
      <div class="activity-info-btn-container" :class="{'hidden': hideActivityInfo}">
        <div v-if="!stackedButtons">
          <button class="how-does-it-work-btn add-pointer">{{$t('activityTypeOverlay.howDoesItWork')}}</button>
          <button class="button-margin-left view-content-list-btn add-pointer">{{$t('activityTypeOverlay.viewContentList')}}</button>
        </div>
        <div v-else>
          <button class="button-display how-does-it-work-btn add-pointer">{{$t('activityTypeOverlay.howDoesItWork')}}</button>
          <button class="button-display view-content-list-btn add-pointer">{{$t('activityTypeOverlay.viewContentList')}}</button>
        </div>
      </div>
    </div>
    <div class="uk-hidden@s">
      <div :class="{'flex-center': !hideActivityInfo, 'flex-top': hideActivityInfo}">
        <img @click="toggleActivityInfo" :class="{'close-icon': !hideActivityInfo, 'open-icon': hideActivityInfo}"
             class="add-pointer icon-size" :data-src="resolveIcon(closeIcon)" width="36px" height="36px" uk-img>
        <img v-if="hideActivityInfo" :data-src="resolveIcon(activityType)" class="icon-size" width="36px" height="36px"
             uk-img>
      </div>
      <div v-if="!hideActivityInfo" class="fade">
        <div class="uk-flex uk-flex-center">
          <img :data-src="resolveIcon(activityType)" class="icon-size icon-margin-left" width="36px" height="36px"
               uk-img>
          <span class="activity-info-title">{{resolveActivity(activityType)}} <br> Activity</span>
        </div>

        <div class="uk-flex uk-flex-center margin-top">
          <button class="how-does-it-work-btn add-pointer">{{$t('activityTypeOverlay.howDoesItWork')}}</button>
        </div>
        <div class="uk-flex uk-flex-center margin-top">
          <button class="view-content-list-btn add-pointer">{{$t('activityTypeOverlay.viewContentList')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import iconUtil from '../../../utils/icon-util'
  import * as activityType from '../../../enums/activity-types'
  import * as misc from '../../../enums/misc'

  export default {
    name: 'activity-type-overlay',
    props: ['activityType'],
    data() {
      return {
        hideActivityInfo: false,
        stackedButtons: false,
        closeIcon: misc.CLOSE_ICON
      }
    },
    methods: {
      toggleActivityInfo() {
        this.hideActivityInfo = !this.hideActivityInfo
      },
      resolveIcon(type) {
        return iconUtil.resolve(type)
      },
      resolveActivity(type) {
        switch (type) {
          case activityType.MONSTER_QUIZ_TYPE:
            return this.$t('activityTypeOverlay.types.monsterQuiz')
          case activityType.SHOUT_IT_OUT_TYPE:
            return this.$t('activityTypeOverlay.types.shoutItOut')
          case activityType.RESPONSE_2_TYPE:
            return this.$t('activityTypeOverlay.types.response2')
          case activityType.SUPER_SORT_TYPE:
            return this.$t('activityTypeOverlay.types.superSort')
          case activityType.LABEL_REVEAL_TYPE:
            return this.$t('activityTypeOverlay.types.labelReveal')
          case activityType.MATCH_EM_UP_TYPE:
            return this.$t('activityTypeOverlay.types.matchEmUp')
          case activityType.SPEED_UP_TYPE:
            return this.$t('activityTypeOverlay.types.speedUp')
          case activityType.FILL_IN_THE_BLANKS_TYPE:
            return this.$t('activityTypeOverlay.types.fillInTheBlanks')
          case activityType.FLIP_OUT_TYPE:
            return this.$t('activityTypeOverlay.types.flipOut')
          case activityType.GAME_SHOW_TYPE:
            return this.$t('activityTypeOverlay.types.gameShow')
          case activityType.RANK_ORDER_TYPE:
            return this.$t('activityTypeOverlay.types.rankOrder')
          case activityType.MEMORY_WATCH_TYPE:
            return this.$t('activityTypeOverlay.types.memoryMatch')

          // case activityType.MONSTER_QUIZ_TYPE:
          //   return activityType.MONSTER_QUIZ_TEXT
          // case activityType.SHOUT_IT_OUT_TYPE:
          //   return activityType.SHOUT_IT_OUT_TEXT
          // case activityType.RESPONSE_2_TYPE:
          //   return activityType.RESPONSE_2_TEXT
          // case activityType.SUPER_SORT_TYPE:
          //   return activityType.SUPER_SORT_TEXT
          // case activityType.LABEL_REVEAL_TYPE:
          //   return activityType.LABEL_REVEAL_TEXT
          // case activityType.MATCH_EM_UP_TYPE:
          //   return activityType.MATCH_EM_UP_TEXT
          // case activityType.SPEED_UP_TYPE:
          //   return activityType.SPEED_UP_TEXT
          // case activityType.FILL_IN_THE_BLANKS_TYPE:
          //   return activityType.FILL_IN_THE_BLANKS_TEXT
          // case activityType.FLIP_OUT_TYPE:
          //   return activityType.FLIP_OUT_TEXT
          // case activityType.GAME_SHOW_TYPE:
          //   return activityType.GAME_SHOW_TEXT
          // case activityType.RANK_ORDER_TYPE:
          //   return activityType.RANK_ORDER_TEXT
          // case activityType.MEMORY_WATCH_TYPE:
          //   return activityType.MEMORY_WATCH_TEXT
        }
      },
      resolveStackedButtons() {
        try {
          let width = document.getElementById('slideshow').offsetWidth
          if (width > 680) {
            this.stackedButtons = false
          } else {
            this.stackedButtons = true
          }
        } catch (err) {
        }
      }
    },
    mounted() {
      this.resolveStackedButtons()
      window.addEventListener('resize', this.resolveStackedButtons)
    },
    destroyed() {
      window.removeEventListener('resize', this.resolveStackedButtons)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours.scss';
  @import '../../../styles/breakpoints.scss';
  @import '../../../styles/box-shadows';

  .activity-info-btn-container {
    position: absolute;
    right: 23px;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out 0.3s;
  }

  .activity-type-container {
    width: 92%;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 0;
    position: absolute;
    z-index: 2;
    margin-left: 4%;
    margin-right: 4%;
    transition: all 0.5s ease-in-out 0s;
  }

  .activity-info-inner-container {
    height: 100%;
    width: 100%
  }

  .activity-info-title {
    width: 177px;
    height: 46px;
    margin-left: 13px;
    color: white;
    font-size: 20px;
    font-weight: bold;
    visibility: visible;
    transition: all 0.5s ease-in-out 0s;
  }

  .button-margin-left {
    margin-left: 23px;
  }

  .button-display {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 7px;
  }

  .close-icon {
    transition: all 0.5s ease-in-out 0s;
  }

  .defaultHeight {
    height: 77px;
  }

  .fade {
    animation: fade-in 0.4s linear 0s;
  }

  .flex-top {
    display: flex;
    align-items: flex-start;
    transition: all 0.2s ease-in-out 0.2s;
    margin-top: 10px;
  }

  .flex-center {
    display: flex;
    align-items: center;
    transition: all 0.5s ease-in-out 0.5s;
  }

  .hidden {
    visibility: hidden;
    opacity: 0;
    transition: all 0.2s ease-in-out 0s;
  }

  .how-does-it-work-btn {
    width: 180px;
    height: 33px;
    border-radius: 2px;
    border: solid 1px $light-gray;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    font-weight: bold;
    color: white;
    &:hover {
      box-shadow: $btn-box-shadow;
      background-color: white;
      color: $content-text;
    }
  }

  .icon-margin-left {
    margin-left: 48px;
  }

  .icon-size {
    /*required for firefox */
    min-width: 36px;
    min-height: 36px;
  }

  .margin-top {
    margin-top: 7px;
  }

  .minimized {
    width: 100px
  }

  .open-icon {
    transition: all 0.5s ease-in-out 0s;
    transform: rotate(45deg);
  }

  .stackedHeight {
    height: 108px;
  }

  .view-content-list-btn {
    width: 180px;
    height: 33px;
    border-radius: 2px;
    border: solid 1px black;
    background-color: $light-gray;
    font-size: 14px;
    font-weight: bold;
    color: $content-text;
    &:hover {
      box-shadow: $btn-box-shadow;
      background-color: white;
      border: 0;
    }
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    90% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media screen and(max-width: $breakpoint-small) {
    .activity-type-container {
      height: 100%;
      transition: all 0.3s ease-in-out 0.3s;
    }
    .minimized {
      width: 80px;
      height: 60px;
    }
  }

</style>
